module.exports = __webpack_public_path__ + "static/media/logo_dark.6d7c28ab.svg";